export default "__VITE_ASSET__De$Yk3Cq__"